import React from 'react';
import { Form, Col, Row } from '../../components/ui-kit';

const DefaultFormGroup = ({ errors, htmlFor, label, required, hint, children }) => {
  errors = errors || [];
  // const validationState = errors.length > 0 ? 'error' : null;
  const errorMessage = errors.join(', ');

  return (
    <Form.Group as={Row} className={'mb-3'}>
      <Form.Label column sm={3} htmlFor={htmlFor}>
        {label} {required && '*'}
      </Form.Label>
      <Col sm={9}>
        {children}
        {errors.length > 0 && <Form.Text className="text-danger">{errorMessage}</Form.Text>}
        {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      </Col>
    </Form.Group>
  );
};

export default DefaultFormGroup;
